import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  AgentId: [],
};
export const sliceKey = 'AgentId';

export const agentIdSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    setAgentId: (state, { payload }) => {
      try {
        state.AgentId = payload;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const { setAgentId } = agentIdSlice.actions;

export default agentIdSlice.reducer;
